import { render } from "./select-form.vue?vue&type=template&id=21f2965a&lang=html"
import script from "./select-form.vue?vue&type=script&lang=js"
export * from "./select-form.vue?vue&type=script&lang=js"

import "./select-form.vue?vue&type=style&index=0&id=21f2965a&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__